/* eslint-disable max-classes-per-file */

export class LoadDocumentEditLock {
  static readonly type = '[Document Edit Lock] Load';
  constructor(public documentId: string) {}
}

export class AcquireDocumentEditLock {
  static readonly type = '[Document Edit Lock] Acquire';
  constructor(public documentId: string) {}
}

export class TryAcquireDocumentEditLock {
  static readonly type = '[Document Edit Lock] Try Acquire';
  constructor(public documentId: string | null | undefined) {}
}

export class HeartbeatDocumentEditLock {
  static readonly type = '[Document Edit Lock] Heartbeat';
}

export class ReleaseDocumentEditLock {
  static readonly type = '[Document Edit Lock] Release';
}

export class ClearDocumentEditLock {
  static readonly type = '[Document Edit Lock] Clear';
}
